export enum ChannelsGroups {
  MyAccounts = 'myacc',
  Others = 'others',
}
